import { render, staticRenderFns } from "./DocumentEditorHeader.vue?vue&type=template&id=6707e970&scoped=true"
import script from "./DocumentEditorHeader.vue?vue&type=script&lang=js"
export * from "./DocumentEditorHeader.vue?vue&type=script&lang=js"
import style0 from "./DocumentEditorHeader.vue?vue&type=style&index=0&id=6707e970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707e970",
  null
  
)

export default component.exports